import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { urgentDate, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	editor: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		minHeight: 0,
	},
	body: {
		flex: 1,
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	fields: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		padding: THEME.spacing.md,
	},
	editorBox: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		minHeight: 96,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		':focus-within': {
			borderColor: THEME.colors.primary.main,
		},
	},
	editorInput: {
		minWidth: 0,
	},
	grid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
		gap: THEME.spacing.md,
		[THEME.queries.md]: {
			gridTemplateColumns: 'minmax(0, 1fr)',
		},
	},
	fullRow: {
		gridColumn: '1 / -1',
	},
	dueRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	dueDate: {
		flex: 1,
		minWidth: 200,
	},
	timeTrigger: {
		flexShrink: 0,
		width: 132,
	},
	selectValue: {
		alignItems: 'center',
		display: 'inline-flex',
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	selectIcon: {
		alignItems: 'center',
		display: 'inline-flex',
		flexShrink: 0,
		height: 16,
		justifyContent: 'center',
		width: 16,
	},
	completedRow: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		gap: THEME.spacing.sm,
		width: 'fit-content',
	},
	pills: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.xs,
	},
	loading: {
		display: 'flex',
		justifyContent: 'center',
		padding: THEME.spacing.md,
	},
	footer: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
		borderTop: THEME.common.border,
		background: white,
	},
	deleteButton: {
		marginLeft: 'auto',
		color: urgentDate,
	},
});
